// Global
export const UPDATE_LANGUAGE_CODE = "UPDATE_LANGUAGE_CODE";

// Student - User
export const UPDATE_STUDENT_USER_INFO = "UPDATE_STUDENT_USER_INFO";

// Dashboard - User
export const UPDATE_DASHBOARD_USER_INFO = "UPDATE_DASHBOARD_USER_INFO";